// Style
import styled from 'styled-components'

// Core
import React, {Fragment} from 'react'

// Components, actions, models, etc.
import {HelpOutline} from '@material-ui/icons'
import Checkbox from 'components/Checkbox'
import type {CheckboxProps} from 'components/Checkbox/Checkbox'
import Tooltip from 'components/Tooltip'
import FormField from './FormField'

const AddonFormField = (props: CheckboxProps) => {
  return (
    <AddonFormField.Styled label='Add Ons'>
      <Checkbox
        label={
          <Fragment>
            <span>Broker Generated Listing Report</span>
            <Tooltip
              text='The MLS sheets provide a comp photo and broker comments that can help the desktop appraiser review and understand comp selection, adjustments, and more.'
              className='tooltip'
            >
              <HelpOutline className='help-icon' />
            </Tooltip>
          </Fragment>
        }
        {...props}
      />
    </AddonFormField.Styled>
  )
}

AddonFormField.Styled = styled(FormField)`
  .help-icon {
    font-size: 1.125rem;
    color: ${({theme}) => theme.colors.stone.base};
    margin-left: 8px;
    vertical-align: -4px;
  }

  .tooltip {
    border-bottom: none;
  }
`
export default AddonFormField
